export interface FeatureDefinition {
  id: string;
  name: string;
  description: string;
  stage: 'early_access' | 'ga';
  defaultEnabled: boolean;
}

export const FEATURE_IDS = {
  SCHOOL_ROTATION_PLANNER: 'school_rotation_planner',
  EXPENSES_TAX_REPORT: 'expenses_tax_report',
  AI_AGENT_ACCESS: 'ai_agent_access',
  AI_LESSON_NOTES: 'ai_lesson_notes',
  EU_LOCALISATION: 'eu_localisation',
  STUDENT_PORTAL: 'student_portal',
} as const;

export const FEATURE_REGISTRY: FeatureDefinition[] = [
  {
    id: FEATURE_IDS.SCHOOL_ROTATION_PLANNER,
    name: 'School rotation planner',
    description: 'Plan term lessons around rotating school timetables (Week A/B)',
    stage: 'early_access',
    defaultEnabled: false,
  },
  {
    id: FEATURE_IDS.EXPENSES_TAX_REPORT,
    name: 'Expenses & year summary',
    description: 'Capture receipts and produce a year summary report for the accountant or tax office',
    stage: 'early_access',
    defaultEnabled: false,
  },
  {
    id: FEATURE_IDS.AI_AGENT_ACCESS,
    name: 'AI agent access (MCP)',
    description: 'Connect an AI assistant (Cursor, Claude, ChatGPT, Grok) to this account over MCP',
    stage: 'early_access',
    defaultEnabled: false,
  },
  {
    id: FEATURE_IDS.AI_LESSON_NOTES,
    name: 'AI lesson notes',
    description: 'Turn a spoken or typed lesson recap into notes and a draft email for parents and the student',
    stage: 'early_access',
    defaultEnabled: false,
  },
  {
    id: FEATURE_IDS.EU_LOCALISATION,
    name: 'European mode',
    description: 'Euro invoices, VAT (BTW), European dates and the Amsterdam timezone',
    stage: 'early_access',
    defaultEnabled: false,
  },
  {
    id: FEATURE_IDS.STUDENT_PORTAL,
    name: 'Student portal',
    description: 'Student accounts, the student portal, and parent booking sessions',
    stage: 'early_access',
    defaultEnabled: false,
  },
];

export function getFeatureDefinition(id: string): FeatureDefinition | undefined {
  return FEATURE_REGISTRY.find((feature) => feature.id === id);
}
